import { RootState } from '@store';

export const selectVehicleModels = (state: RootState) => {
  return state.vehicleModels?.vehicleModels;
};

export const selectVehicleModelResults = (state: RootState) => {
  return state.vehicleModels?.vehicleModels?.results;
};

export const selectVehicleModelData = (state: RootState) => {
  return state.vehicleModels?.vehicleModelData;
};

export const selectVehicleModelVehicleType = (state: RootState) => {
  return selectVehicleModels(state)?.results?.[0]?.model?.vehicleType;
};
